import type { ReactElement } from 'react';
import { Link } from 'react-router';
import { routePaths } from '@/app/route-paths';

export function NotFoundRoute(): ReactElement {
  return (
    <main className="flex min-h-dvh flex-col items-center justify-center gap-4 p-gutter text-center">
      <p className="text-sm font-medium tracking-wide text-fg-muted uppercase">Not found</p>
      <h1 className="text-2xl font-semibold">That page does not exist</h1>
      <Link
        to={routePaths.dashboard}
        className="rounded-control bg-brand-600 px-4 py-2 text-sm font-medium text-white hover:bg-brand-700"
      >
        Back to overview
      </Link>
    </main>
  );
}
